if (!customElements.get('ds-product-card-element')) {
  class DsProductCardElement extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';

      this.imageWrapper = this.querySelector('.ds-product-card__image-wrapper');
      this.primaryImage = this.querySelector('.ds-product-card__image--primary');
      this.secondaryImage = this.querySelector('.ds-product-card__image--secondary');

      if (this.dataset.swatchMode === 'random') this.activateRandomSwatch();

      this.addEventListener('click', (event) => {
        const swatch = event.target.closest('.ds-swatch');
        if (!swatch || !this.contains(swatch)) return;

        event.preventDefault();
        event.stopPropagation();

        this.setImages({
          imageUrl: swatch.dataset.imageUrl,
          imageSrcset: swatch.dataset.srcset,
          secondaryImageUrl: swatch.dataset.secondaryImageUrl,
          secondarySrcset: swatch.dataset.secondarySrcset,
        });
        this.setCardLink(swatch.dataset.variantUrl);

        this.querySelectorAll('.ds-swatch').forEach((node) => {
          node.classList.remove('is-active');
          node.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('is-active');
        swatch.setAttribute('aria-pressed', 'true');
      });
    }

    activateRandomSwatch() {
      const swatches = Array.from(this.querySelectorAll('.ds-swatch')).filter(
        (swatch) => swatch.dataset.imageUrl
      );
      if (swatches.length < 2) return;

      const pick = swatches[Math.floor(Math.random() * swatches.length)];
      if (pick.classList.contains('is-active')) return;

      this.setImages({
        imageUrl: pick.dataset.imageUrl,
        imageSrcset: pick.dataset.srcset,
        secondaryImageUrl: pick.dataset.secondaryImageUrl,
        secondarySrcset: pick.dataset.secondarySrcset,
      });
      this.setCardLink(pick.dataset.variantUrl);

      this.querySelectorAll('.ds-swatch').forEach((node) => {
        node.classList.remove('is-active');
        node.setAttribute('aria-pressed', 'false');
      });
      pick.classList.add('is-active');
      pick.setAttribute('aria-pressed', 'true');
    }

    // Swatches without data-variant-url (no resolvable variant) leave the
    // rendered link untouched.
    setCardLink(variantUrl) {
      if (!variantUrl) return;
      this.querySelectorAll('a.ds-product-card__link').forEach((link) => {
        link.setAttribute('href', variantUrl);
      });
    }

    setImages({ imageUrl, imageSrcset, secondaryImageUrl, secondarySrcset }) {
      if (!this.primaryImage) return;

      if (imageUrl) this.primaryImage.src = imageUrl;
      if (imageSrcset) {
        this.primaryImage.srcset = imageSrcset;
      } else if (imageUrl) {
        this.primaryImage.removeAttribute('srcset');
      }

      if (!this.secondaryImage || !this.imageWrapper) return;

      if (secondaryImageUrl) {
        this.secondaryImage.src = secondaryImageUrl;
        if (secondarySrcset) {
          this.secondaryImage.srcset = secondarySrcset;
        } else {
          this.secondaryImage.removeAttribute('srcset');
        }
        this.secondaryImage.hidden = false;
        this.imageWrapper.classList.add('ds-product-card__image-wrapper--has-secondary');
      } else {
        this.secondaryImage.removeAttribute('src');
        this.secondaryImage.removeAttribute('srcset');
        this.secondaryImage.hidden = true;
        this.imageWrapper.classList.remove('ds-product-card__image-wrapper--has-secondary');
      }
    }
  }

  customElements.define('ds-product-card-element', DsProductCardElement);
}
